import Component from '../lib/Component'

export default class ReCaptcha extends Component {
  constructor(elem, APP) {
    super(elem, APP)
    this.formID = this.elem.getAttribute('data-form-id')
    this.formElem = document.getElementById(this.formID)
    this.submitBtn = document.querySelector('.g-recaptcha')
    this.siteKey = this.elem.getAttribute('data-sitekey')
  }

  addScript() {
    const script = document.createElement('script')
    script.async = true
    script.defer = true
    script.src = 'https://www.google.com/recaptcha/api.js?onload=_reCaptchaOnLoad&render=explicit'
    document.querySelector('head').appendChild(script)
  }

  renderReCaptcha() {
    window.grecaptcha.render(this.elem, {
      sitekey: this.siteKey,
      callback: function () {

        return new Promise(function (resolve, reject) {

          if (grecaptcha === undefined) {
            console.log('Recaptcha undefined');
            reject();
            grecaptcha.reset();
          }

          var response = grecaptcha.getResponse();

          if (!response) {
            console.log('Coud not get recaptcha response');
            reject();
            grecaptcha.reset();
          } else {
            // if (document.querySelector('.g-recaptcha')) {
            //   document.querySelector('.g-recaptcha').disabled = false
            // }
            resolve();
          }
        }); //end promise

      }
    })
 
    this.submitBtn.addEventListener('click', () => {
      let response = grecaptcha.getResponse();
      if(!response) {
        console.log('clicked!')
        this.elem.insertAdjacentHTML('beforebegin', '<span>Please complete the form.</span>')
      }
    })
  }

  init() {
    let self = this
    if (window.grecaptcha) {
      self.renderReCaptcha()
    } else {
      this.addScript()
      window._reCaptchaOnLoad = function () {
        self.renderReCaptcha()
      }
    }
  }
}
